import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import TextField from "@mui/material/TextField";
import { useMaterialUIController, setDirection } from "context";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { Height } from "@mui/icons-material";
import { width } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { CardContent, Chip, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VerifiedIcon from "@mui/icons-material/Verified";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import AddBankAccountModal from "../../components/AddBankAccounModal";
import EditIcon from "@mui/icons-material/Edit";
import RowsPerPageSelector from "components/RowsPerPageSelector";

function BankAccounts() {
  const [controller, dispatch] = useMaterialUIController();
  const [BankAccounts, setBankAccounts] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    setDirection(dispatch, "rtl");
    fetchBankAccounts();
    return () => setDirection(dispatch, "ltr");
  }, []);

  const fetchBankAccounts = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/bank-accounts", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setBankAccounts(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching BankAccounts:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredAccounts = BankAccounts.filter(
    (acc) =>
      acc.name?.toLowerCase().includes(search.toLowerCase()) ||
      acc.account?.toLowerCase().includes(search.toLowerCase())
  );
  const paginatedAccounts = filteredAccounts.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    setPage(0);
  }, [search, rowsPerPage]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
        width="100vw"
        position="fixed"
        top={0}
        left={0}
        zIndex={2000}
        bgcolor="rgba(255,255,255,0.8)"
      >
        <CircularProgress size={60} sx={{ color: "#ca9937" }} />
      </Box>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddBankAccountModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchBankAccounts}
        initialData={currentUser}
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              حساباتي البنكية
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              حساب جديد
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <TextField
              fullWidth
              label="بحث باسم أو رقم الحساب"
              variant="outlined"
              size="small"
              sx={{ mb: 3 }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <MDBox mb={2} display="flex">
              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      {filteredAccounts.length === 0 ? (
        <Typography align="center" color="text.secondary" mt={4}>
          لا توجد حسابات بنكية مسجلة
        </Typography>
      ) : (
        <>
          <Grid container spacing={3}>
            {paginatedAccounts.map((acc) => (
              <Grid item xs={12} md={6} lg={4} key={acc.id}>
                <Card
                  sx={{
                    border: acc.is_default ? "2px solid #43cea2" : "1px solid #eee",
                    boxShadow: acc.is_default ? 4 : 1,
                    position: "relative",
                    background: acc.is_default
                      ? "linear-gradient(90deg, #43cea2 0%, #185a9d 100%)"
                      : "#fff",
                    color: acc.is_default ? "white" : "inherit",
                  }}
                >
                  <CardContent>
                    <Box display="flex" alignItems="center" mb={1}>
                      <Typography variant="h6" fontWeight="bold" flex={1}>
                        {acc.name}
                      </Typography>
                      {acc.is_default && (
                        <Chip
                          label="افتراضي"
                          color="success"
                          size="small"
                          icon={<CheckCircleIcon />}
                          sx={{ ml: 1, color: "white", background: "#43cea2" }}
                        />
                      )}
                      {acc.is_verified ? (
                        <Chip
                          label="موثق"
                          color="info"
                          size="small"
                          icon={<VerifiedIcon />}
                          sx={{ ml: 1 }}
                        />
                      ) : (
                        <Chip
                          label="غير موثق"
                          color="warning"
                          size="small"
                          icon={<ErrorOutlineIcon />}
                          sx={{ ml: 1 }}
                        />
                      )}
                    </Box>
                    <Typography variant="body2" fontWeight="bold">
                      رقم الحساب:{" "}
                      <span style={{ direction: "ltr", unicodeBidi: "bidi-override" }}>
                        {acc.account}
                      </span>
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" mt={1}>
                      IBAN:{" "}
                      <span style={{ direction: "ltr", unicodeBidi: "bidi-override" }}>
                        {acc.iban}
                      </span>
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mt={1}>
                      تاريخ الإضافة: {new Date(acc.created_at).toLocaleDateString("ar-EG")}
                    </Typography>
                    <Box display="flex" justifyContent="flex-end" alignItems="center" mt={2}>
                      <Box flex={1} />
                      <IconButton
                        aria-label="edit"
                        color="primary"
                        sx={{ ml: "auto", background: "#f5f5f5", borderRadius: 2 }}
                        onClick={() => {
                          setCurrentUser(acc);
                          setModalOpen(true);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
            <MDButton
              onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
              disabled={page === 0}
              sx={{
                background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                mx: 1,
                "&:hover": {
                  background: "linear-gradient(90deg, #b6842f, #d39d45)",
                },
              }}
            >
              <ArrowBackIcon />
            </MDButton>
            <MDTypography
              variant="button"
              color="text"
              sx={{
                display: "flex",
                alignItems: "center",
                mx: 3,
                fontWeight: "bold",
              }}
            >
              الصفحة {page + 1} من {Math.ceil(filteredAccounts.length / rowsPerPage)}
            </MDTypography>
            <MDButton
              onClick={() =>
                setPage((prev) =>
                  (prev + 1) * rowsPerPage >= filteredAccounts.length ? prev : prev + 1
                )
              }
              disabled={(page + 1) * rowsPerPage >= filteredAccounts.length}
              sx={{
                background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                mx: 1,
                "&:hover": {
                  background: "linear-gradient(90deg, #b6842f, #d39d45)",
                },
              }}
            >
              <ArrowForwardIcon />
            </MDButton>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  );
}

export default BankAccounts;
